import { isEqual } from 'lodash';
import {
    CurrentAccommodationSearchSessionStorage,
    CurrentSearchToSessionStorageValues,
    CurrentSearchToReduxStoreValues, RecentAccommodationSearchesLocalStorage
} from '../utils';
import { updateSegment } from '../redux/currentSearch/actions';
import { EntryPoint } from '../models';
import { isValidAccommodationSearch } from './currentSearch/isValidAccommodationSearch';
import { synchronizeRooms } from './currentSearch/synchronizeRooms';

const updateReduxStoreOrInitializeSessionStorage = ({ activeProduct: { activeProduct }, currentSearch: currentSearchRedux }, dispatch) => {
    const currentAccommodationSearch = CurrentAccommodationSearchSessionStorage.getAccommodationCurrentSearch();
    const currentSearchSessionStorageValues = CurrentSearchToSessionStorageValues(currentSearchRedux);
    const isAccommodationValid = isValidAccommodationSearch(currentAccommodationSearch);

    if (activeProduct === EntryPoint.HOTELS) {
        if (
            isAccommodationValid &&
            !isEqual(currentAccommodationSearch, currentSearchSessionStorageValues)
        ) {
            const currentAccommodationSearchRedux = CurrentSearchToReduxStoreValues(currentAccommodationSearch);

            // If currentAccommodationSearch is filled and different from state.currentSearch, dispatch actions to update Redux store
            dispatch(updateSegment(currentAccommodationSearchRedux.segments[0], currentSearchRedux.segments[0].id));
            dispatch(updateSegment(currentAccommodationSearchRedux.segments[1], currentSearchRedux.segments[1].id));
            synchronizeRooms({
                currentSearchRedux: currentSearchRedux,
                currentAccommodationSearch: currentAccommodationSearch
            }, dispatch);
        } else if (!isAccommodationValid) {
            const recentAccommodationSearch = RecentAccommodationSearchesLocalStorage.getAccommodationMostRecentSearch();
            if (recentAccommodationSearch) {
                synchronizeRooms({
                    currentSearchRedux: currentSearchRedux,
                    currentAccommodationSearch: { rooms: recentAccommodationSearch.rooms.map((room, i) => ({
                        id: Date.now() + i,
                        adults: room.numAdults,
                        kids: room.childrenAges || []
                    })) }
                }, dispatch);
            }
        } else {
            CurrentAccommodationSearchSessionStorage.setInitialState(currentSearchSessionStorageValues);
        }
    }
};

export const CurrentAccommodationSearchService = {
    updateReduxStoreOrInitializeSessionStorage,
};
